export const isUnread = (application: wowaudit.Application) => {
  const readLocally = localStorage.getItem(`application_${application.id}_read`)

  return (
    !readLocally &&
    !application.timestamps &&
    ['pending', 'under_review'].includes(application.status)
  )
}

export const urlToMainSite = (path: string) => {
  return `http${
    window.location.host.includes('local') ? '' : 's'
  }://${window.location.host.replace('apply.', '')}${path}`
}

export const legacyBackgroundStyle = (value?: string) => {
  if (!value) return {}

  return value.length === 7 && value.startsWith('#')
    ? { backgroundColor: value }
    : { backgroundImage: `url(${value})` }
}

export const defaultLegacyFormColors = {
  css_background: 'https://data.wowaudit.com/img/default-background.jpg',
  css_body: '#170e09',
  css_headers: '#e8672f',
  css_text: '#b9b7b6',
  css_inputs: '#1f1814',
  css_header_bar: '#9b3e11',
} as const
